import { PostEvent, PostEventInput } from "types/Post";

/** The composer's event fields as typed: the value formats of <input type="date"> and <input type="time">. */
export interface EventFormValues {
  title: string;
  /** 'YYYY-MM-DD' */
  date: string;
  /** 'HH:mm' */
  time: string;
  location: string;
}

export const EMPTY_EVENT_FORM: EventFormValues = { title: "", date: "", time: "", location: "" };

/** Fields of an existing event, for editing it. */
export const eventFormFromEvent = (event: PostEvent): EventFormValues => {
  const startsAt = new Date(event.startsAt);
  const pad = (value: number) => String(value).padStart(2, "0");
  return {
    title: event.title,
    date: `${startsAt.getFullYear()}-${pad(startsAt.getMonth() + 1)}-${pad(startsAt.getDate())}`,
    time: `${pad(startsAt.getHours())}:${pad(startsAt.getMinutes())}`,
    location: event.location ?? "",
  };
};

/** The body the server takes, or null while the title, date or time is still missing. */
export const eventFormToInput = (values: EventFormValues): PostEventInput | null => {
  const title = values.title.trim();
  const date = /^(\d{4})-(\d{2})-(\d{2})$/.exec(values.date);
  // Some browsers send seconds (HH:mm:ss); they are ignored.
  const time = /^(\d{2}):(\d{2})(?::\d{2}(?:\.\d+)?)?$/.exec(values.time);
  if (!title || !date || !time) return null;

  const startsAt = new Date(Number(date[1]), Number(date[2]) - 1, Number(date[3]), Number(time[1]), Number(time[2])).getTime();
  if (Number.isNaN(startsAt)) return null;

  const location = values.location.trim();
  return location ? { title, startsAt, location } : { title, startsAt };
};
